<template>
    <div class="app-left-content-header">
        <h1 class="content-title">Panel de Usuarios</h1>
        <button class="add-user-button" @click="openAddModal">Agregar Usuario</button>
        <button class="add-user-button-mobile"><i class="bi bi-person-fill-add" @click="openAddModal"></i></button>
    </div>

    <div class="app-content-field">
        <div class="container">
            <div class="table-filter-wrapper ">
                <input class="filter-search-input" type="text" placeholder="Buscar en la tabla..." />
            </div>
            <ul class="responsive-table">
                <li class="table-header">
                    <div class="col col-1">Nombre</div>
                    <div class="col col-2">Email</div>
                    <div class="col col-3">Departamento</div>
                    <div class="col col-4">Estatus</div>
                    <div class="col col-5"></div>
                </li>
                <li class="table-row">
                    <div class="col col-1" data-label="Nombre">Karen Carballo Camacho</div>
                    <div class="col col-2" data-label="Email">kcarballo@fletes-mexico.com</div>
                    <div class="col col-3" data-label="Departamento">Sistemas</div>
                    <div class="col col-4" data-label="Estatus">Activo</div>
                    <div class="col col-5">
                        <button class="edit-button" @click="openEditModal"><i class="bi bi-pen-fill"></i></button>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <ModalUsersPanel v-model="showAddModal" />
    <ModalEditUser v-model="showEditModal" />
</template>

<script setup>
import { ref } from 'vue';
import ModalUsersPanel from '@/components/ModalUsersPanel.vue';
import ModalEditUser from '@/components/ModalEditUser.vue';

const showEditModal = ref(false);
const openEditModal = () => {
    showEditModal.value = true;
};

const showAddModal = ref(false);
const openAddModal = () => {
    showAddModal.value = true;
};
</script>

<style scoped src="../styles/usersPanel.css"></style>
<style scoped src="../styles/tableUsersPanel.css"></style>